import { render, staticRenderFns } from "./SetNet.vue?vue&type=template&id=0c54b0ae&scoped=true&"
import script from "./SetNet.vue?vue&type=script&lang=js&"
export * from "./SetNet.vue?vue&type=script&lang=js&"
import style0 from "./SetNet.vue?vue&type=style&index=0&id=0c54b0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54b0ae",
  null
  
)

export default component.exports